import useAxios from 'axios-hooks'
import React from 'react'
import * as Icon from 'react-feather'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { ButtonTemplate, Header } from './styles'
import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import QuestionCard from '~/components/QuestionCard'

const QuestionsHeaderMenu = () => {
  return (
    <div className="d-flex align-items-center justify-content-center mb-2 mb-sm-0">
      <ButtonTemplate to="/templates/reviews" className="ml-2">
        <Icon.FileText height={14} className="d-none d-md-block" />
        <FormattedMessage id="Template Gallery" />
      </ButtonTemplate>
    </div>
  )
}

const SingleReview = () => {
  const { questionId } = useParams()

  const accountId = useSelector(state => state?.user?.profile?.account?.id)

  const [{ data, loading }] = useAxios({
    method: 'GET',
    url: `/questions/${encodeURIComponent(questionId)}`,
  })

  const [{ data: templates }] = useAxios(`/templates/reviews/${accountId}`, {
    useCache: false,
  })

  return (
    <>
      <Header>
        <BreadcrumbHeader
          path={[
            { name: 'Locations', path: '/' },
            { name: 'Reply Question', path: 'questions' },
          ]}
        >
          <QuestionsHeaderMenu />
        </BreadcrumbHeader>
      </Header>
      {!loading && <QuestionCard question={data} templates={templates || []} />}
    </>
  )
}

export default SingleReview
